import React, { useState, useEffect } from "react";
import "./QRPopup.css";
import doctorImg from '../../Assets/Banner/doctorB.jpeg'

const QRPopup = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [formData, setFormData] = useState({ name: "", mobile: "", about: "" });

  useEffect(() => {
    const wasPopupClosed = sessionStorage.getItem("qrPopupClosed");
    if (!wasPopupClosed) {
      setIsOpen(true);
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    if (!formData.name.trim() || !formData.mobile.trim()) return;
    try {
      const response = await fetch("https://api.swasthmitra.com/api/lead/submit", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      if (response.ok) {
        setIsOpen(false);
        setShowConfirmation(true);
        sessionStorage.setItem("qrPopupClosed", "true");
      } else {
        alert("Error submitting form");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleClose = () => {
    setIsOpen(false);
    setShowConfirmation(false);
    sessionStorage.setItem("qrPopupClosed", "true");
  };

  return (
    <>
      {isOpen && (
        <div className="qr-overlay">
          <div className="qr-container">
            {/* Close Button */}
            <button className="qr-close-btn" onClick={handleClose}>✕</button>

            {/* Siren — centered top */}
            <div className="qr-siren-top">🚨</div>

            {/* Hero Row: Text left, Doctor right */}
            <div className="qr-hero">
              <div className="qr-hero-left">
                <h2 className="qr-headline">
                  दवा के लिए<br />
                  <span className="qr-headline-red">भाग-दौड़ से परेशान?</span>
                </h2>
                <div className="qr-divider">
                  <span className="qr-shield">🛡️</span>
                </div>
                <p className="qr-subtext">
                  अब डॉक्टर की लिखी दवा<br />
                  <span className="qr-subtext-green">घर बैठे पाएँ – समय और पैसे दोनों बचाएँ</span>
                </p>
              </div>
              <div className="qr-doctor-img">
                <img src={doctorImg} alt="Doctor" className="doctor-img" />
              </div>
            </div>

            {/* Trust Badges */}
            <div className="qr-badges">
              <div className="qr-badge">
                <span className="badge-icon teal">✔</span>
                <span>35 साल<br />का भरोसा</span>
              </div>
              <div className="qr-badge">
                <span className="badge-icon purple">👥</span>
                <span>लाखों मरीजों<br />का विश्वास</span>
              </div>
              <div className="qr-badge">
                <span className="badge-icon blue">🚚</span>
                <span>तेज़ और सुरक्षित<br />डिलीवरी</span>
              </div>
              <div className="qr-badge">
                <span className="badge-icon gold">✔</span>
                <span>100% असली<br />दवाएँ</span>
              </div>
            </div>

            {/* Form Fields */}
            <div className="qr-input-row">
              <span className="qr-input-icon">👤</span>
              <input
                type="text"
                name="name"
                placeholder="नाम [Name]"
                value={formData.name}
                onChange={handleChange}
                required
                className="qr-mobile-input"
              />
            </div>

            <div className="qr-input-row">
              <span className="qr-input-icon">📱</span>
              <input
                type="tel"
                name="mobile"
                placeholder="मोबाइल नंबर दर्ज करें"
                value={formData.mobile}
                onChange={handleChange}
                required
                className="qr-mobile-input"
              />
            </div>

            <div className="qr-input-row">
              <span className="qr-input-icon">💊</span>
              <select
                name="about"
                value={formData.about}
                onChange={handleChange}
                className="qr-mobile-input qr-select"
              >
                <option value="">क्या मदद चाहिए?</option>
                <option value="दवाई लेनी है।">दवाई लेनी है।</option>
                <option value="डॉक्टर से मिलना है।">डॉक्टर को दिखाना है।</option>
                <option value="जाँच करवानी है।">जाँच करवानी है।</option>
              </select>
            </div>

            {/* CTA Button */}
            <button className="qr-cta-btn" onClick={handleSubmit}>
              📞 &nbsp; अभी दवा मंगवाएं
            </button>

            {/* Privacy Note */}
            <p className="qr-privacy">🔒 आपकी जानकारी सुरक्षित है और किसी के साथ साझा नहीं की जाएगी</p>

            {/* Bottom Features */}
            <div className="qr-features">
              <div className="qr-feature">
                <span className="feature-icon green-bg">🎧</span>
                <span>फार्मासिस्ट से<br />सीधी बात करें</span>
              </div>
              <div className="qr-feature">
                <span className="feature-icon blue-bg">📋</span>
                <span>डॉक्टर की पर्ची<br />अपलोड करें</span>
              </div>
              <div className="qr-feature">
                <span className="feature-icon red-bg">🏠</span>
                <span>दवा सीधे<br />घर तक पाएँ</span>
              </div>
            </div>

            {/* Bottom shield */}
            <div className="qr-bottom-shield">🛡️</div>
          </div>
        </div>
      )}

      {showConfirmation && (
        <div className="qr-overlay">
          <div className="qr-confirm-container">
            <button className="qr-close-btn" onClick={handleClose}>✕</button>
            <div className="qr-success-icon">
              <svg className="checkmark1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                <circle className="checkmark1-circle" cx="26" cy="26" r="25" fill="none" />
                <path className="checkmark1-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
              </svg>
            </div>
            <h2 className="qr-confirm-title">Form Submitted Successfully!</h2>
            <p className="qr-confirm-sub">We will contact you soon.</p>
          </div>
        </div>
      )}
    </>
  );
};

export default QRPopup;